import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { renderNotiBody, renderNotiTitle, useOnClickResponse } from "./config";
import { Trans } from "react-i18next";

export const Notification = ({ n, toggle = () => { } }) => {
  const [seconds, setSeconds] = useState();
  const { onClick } = useOnClickResponse({ n, toggle });

  useEffect(() => {
    if (n.createdAt) {
      setSeconds(parseInt(moment.duration(moment().diff(moment(n.createdAt))).asSeconds()));
    }
    const i = setInterval(() => setSeconds((p) => p + 1), 1000);
    return () => clearInterval(i);
  }, [n]);

  const getSeconds = () => {
    if (seconds <= 60) {
      return (
        <Trans i18nKey="secAgo">
          {{ sec: seconds }}
        </Trans>
      )
    }

    if (seconds <= (60 * 60)) {
      const min = Math.floor(seconds / 60);
      return (
        <Trans i18nKey="minAgo">
          {{ min }}
        </Trans>
      )
    }

    if (seconds <= (60 * 60 * 24)) {
      const hours = Math.floor(seconds / 60 / 60);
      return (
        <Trans i18nKey="hoursAgo">
          {{ hours }}
        </Trans>
      )
    }

    const days = Math.floor(seconds / 60 / 60 / 24);
    return (
      <Trans i18nKey="daysAgo">
        {{ days }}
      </Trans>
    )
  };

  const body = useMemo(() => renderNotiBody({ n }), [n]);

  return (
    <div className="noti" onClick={onClick}>
      <div className="noti-main">
        <div className="noti-head">
          <h5>{renderNotiTitle({ n })}</h5>
          <span>
            {getSeconds()}
          </span>
        </div>
        <div className="cont j-c clickable">
          {body}
        </div>
      </div>
      {!n.read ? (
        <div className="not-read">
          <div className="bullet" />
        </div>
      ) : null}
    </div>
  );
}
